module.exports = __webpack_public_path__ + "/static/assets/3d9e2585d6ed12b9fb994438e0c4c42a.svg";